import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const HorizontalLayout = forwardRef<SVGSVGElement | null, IconFilledProps>(function HorizontalLayout(
  { filled, dataTestId, ...props },
  ref,
) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M19 9.75C19.1381 9.75 19.25 9.63807 19.25 9.5L19.25 5C19.25 4.86193 19.1381 4.75 19 4.75L5 4.75C4.86193 4.75 4.75 4.86193 4.75 5L4.75 9.5C4.75 9.63807 4.86193 9.75 5 9.75L19 9.75ZM5 11.25C4.0335 11.25 3.25 10.4665 3.25 9.5L3.25 5C3.25 4.0335 4.0335 3.25 5 3.25L19 3.25C19.9665 3.25 20.75 4.0335 20.75 5L20.75 9.5C20.75 10.4665 19.9665 11.25 19 11.25L5 11.25Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M19 19.25C19.1381 19.25 19.25 19.1381 19.25 19L19.25 14.5C19.25 14.3619 19.1381 14.25 19 14.25L5 14.25C4.86193 14.25 4.75 14.3619 4.75 14.5L4.75 19C4.75 19.1381 4.86193 19.25 5 19.25L19 19.25ZM5 20.75C4.0335 20.75 3.25 19.9665 3.25 19L3.25 14.5C3.25 13.5335 4.0335 12.75 5 12.75L19 12.75C19.9665 12.75 20.75 13.5335 20.75 14.5L20.75 19C20.75 19.9665 19.9665 20.75 19 20.75L5 20.75Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M19 12.75C19.9665 12.75 20.75 13.5335 20.75 14.5V19C20.75 19.9665 19.9665 20.75 19 20.75H5C4.0335 20.75 3.25 19.9665 3.25 19V14.5C3.25 13.5335 4.0335 12.75 5 12.75H19Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M19 3.25C19.9665 3.25 20.75 4.0335 20.75 5V9.5C20.75 10.4665 19.9665 11.25 19 11.25H5C4.0335 11.25 3.25 10.4665 3.25 9.5V5C3.25 4.0335 4.0335 3.25 5 3.25H19Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'horizontal-layout-icon-svg'} iconRender={iconRender} {...props} />;
});

export default HorizontalLayout;
